import type { ChatMessage } from '@/shared/lib/livekit'

export function buildChatMessage(text: string): ChatMessage {
  return { kind: 'chat', id: globalThis.crypto.randomUUID(), text, sentAt: Date.now() }
}
